"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gerenciatdUtils = require("@bit/gerenciatd.utils.react-utils");

require("./LinkOverBoxContainer.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LinkOverBoxContainer = function LinkOverBoxContainer(_ref) {
  var children = _ref.children;
  var numberOfTagObj = (0, _gerenciatdUtils.numberOfSpecificTag)('LinkOverBox', children);

  if (numberOfTagObj.childTags === 1) {
    if (numberOfTagObj.internalTags !== 0) {
      console.warn("LinkOverBoxContainer can only contains one, and only one LinkOverBox component as direct child. You've got indirect LinkOverBox children");
    }
  }

  console.warn("LinkOverBoxContainer can only contains one, and only one LinkOverBox component as direct child. You've got more than one");
  return _react.default.createElement("div", {
    className: "linkOverBoxContainer"
  }, children);
};

LinkOverBoxContainer.propTypes = {
  children: _propTypes.default.node.isRequired
};
var _default = LinkOverBoxContainer;
exports.default = _default;

//# sourceMappingURL=index.js.map